export type ExtractorWithVisibility = {
  visible?: boolean;
};

export const filterVisibleExtractors = <T extends ExtractorWithVisibility>(
  extractors: T[]
): T[] => {
  return extractors.filter((extractor) => extractor.visible === true);
};
